import { useMemo } from 'react';
import { Element } from 'react-bulma-components';
import { environment } from '../../../environments/environment';
import Link from '../link/link';
import styles from './footer.module.scss';

export function Footer() {
  const appVersion = useMemo(() => {
    const version = environment.appVersion;
    return `v${version}`;
  }, []);
  return (
    <Element
      display="flex"
      className={`${styles.footer} is-hidden-mobile`}
      py={4}
    >
      <Element display="flex" className="w-full gap-8">
        <span className={styles.footerItem}>
          © {new Date().getFullYear()} zSpace, Inc.
        </span>
        <Link
          to={environment.termsOfUseUrl}
          className={styles.footerItem}
          disableHoverInteraction
          openNewTab
        >
          Terms of use
        </Link>
        <Link
          to={environment.privacyPolicyUrl}
          className={styles.footerItem}
          disableHoverInteraction
          openNewTab
        >
          Privacy Policy
        </Link>
        <Link
          to={environment.legalUrl}
          className={styles.footerItem}
          disableHoverInteraction
          openNewTab
        >
          Legal
        </Link>
      </Element>
      <Element>
        <span className={styles.footerItem}>{appVersion}</span>
      </Element>
    </Element>
  );
}

export default Footer;
